import { Component } from '@angular/core';
import { SocoHttpService } from '@app/soco/http/soco-http.service';
declare const $;

@Component({
  selector: 'soco-please-wait',
  template: ``
})
export class SocoPleaseWaitComponent {
  constructor(private http: SocoHttpService) {
    http.pleaseWaitShown$.subscribe(options => {
      this.show(options);
    });
    http.pleaseWaitHidden$.subscribe(containerId => {
      this.hide(containerId);
    });
  }

  private show(options: any): void {
    $(`#${options.containerId}`).block(this.getOptions(options.message ? options.message : 'Processing.'));
  }

  private hide(containerId: any): void {
    $(`#${containerId}`).unblock();
  }

  private getOptions(message: string) {
    return {
      message: `<div class="block-ui-container"><i class="icon-spinner2 spinner position-left"></i><br />${message}</div>`,
      overlayCSS: {
        backgroundColor: '#fff',
        opacity: 0.60,
        cursor: 'wait',
        'box-shadow': '0 0 0 1px #ddd'
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: 'none'
      }
    };
  }
}
